<template>
  <div class="col-md-12 console_commands">
    <div
        class="main_filters"
        :class="filters_state ? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span class="mdi" :class="filters_state ? 'mdi-filter-remove' : 'mdi-filter'" />
      <span class="main_fiters_toggler_text">
        {{ filters_state ? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state ? 'shown' : 'hidden'">
        <div class="form_select" v-for="key in ['q', 'controller_id']" :key="key">
          <fg-input
              v-model="filter[key]"
              type="text"
              :label="translate('utilities.commands.' + key)"
              :placeholder="translate('utilities.commands.' + key)"
              :clearable="true"
          />
        </div>
        <div class="form_select"></div>
        <div class="form_select"></div>
      </div>
    </div>

    <div class="response_table">
      <div class="spinner" v-if="loading"><scale-loader /></div>
      <p v-else-if="!command_list.length">{{ translate('no_data') }}</p>
      <table v-else>
        <thead>
          <tr>
            <th v-for="column in columns" :key="column" scope="col"
                class="pointer"
                @click="change_filter(column)"
                :class="{ selected: filter_type === column, 'text-left': column === 'route' || column === 'crontab' || column === 'description' }">
              {{ translate('utilities.commands.' + column) }}
              <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, key) in commands" :key="key">
            <td
                v-for="column in columns"
                :key="column"
                :data-label="translate('utilities.commands.' + column)"
                :class="{ 'text-left': column === 'route' || column === 'crontab' || column === 'description' }"
            >
              {{ column === "synced_at" ? get_date(item[column]) : item[column] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsoleCommands',
  data () {
    return {
      command_list: [],
      filter_type: "",
      filter_asc: "asc",
      columns: ['route', 'crontab', 'description', 'synced_at'],
      filter: {q: '', controller_id: ''},
      loading: false,
      timer: null,
      request_id: 0,
      filters_state: this.localStorage.getItem('filters_state') !== 'false'
    }
  },
  computed: {
    commands(){
      let commands = [...this.command_list]
      return commands.sort(this.compareNumbers)
    },
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        clearTimeout(this.timer)
        this.request_id++
        this.timer = setTimeout(this.load_commands, 300)
      }
    }
  },
  created () {
    this.load_commands()
  },
  beforeDestroy () {
    clearTimeout(this.timer)
    this.request_id++
  },
  methods: {
    load_commands() {
      if (!this.$store.getters.getPermissions.permissionGod) return
      const request_id = ++this.request_id
      const params = {...this.filter}
      Object.keys(params).forEach(key => {
        if (params[key] === '') delete params[key]
      })
      this.loading = true
      this.$http.v1.getConsoleCommandCatalog(params, (response) => {
        if (request_id !== this.request_id) return
        this.command_list = response.data.data ?? response.data
        this.loading = false
      }, () => {
        if (request_id !== this.request_id) return
        this.loading = false
        this.global_notify('danger', this.translate('utilities.load_error'))
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>
.console_commands{
  height: 100%;
  display: flex;
  flex-direction: column;
  .main_filters{
    top: 20px;
  }
  .header{
    display: flex;
    align-items: flex-end;
    gap: 10px;
    .form_select{
      flex: 1;
      min-width: 0;
      .form-group{
        margin-bottom: 0;
      }
    }
  }
  .response_table{
    padding-left: 0;
    padding-right: 0;

    th, td{
      font-size: 12px;
      overflow-wrap: anywhere;
    }

    .text-left{
      text-align: left;
    }
  }
}
</style>
